import {jwtDecode} from "jwt-decode";
// import { logoutLocalStorage } from "../../../features/auth/authActions";


/**
 * POST request to api
 * @param {*} url
 * @param {*} model
 * @param {*} noToken
 * @returns
 */
export function httpPost(url, model, noToken) {
	return request(url, model, "POST", noToken);
}

/**
 * GET request to api
 * @param {*} url
 * @param {*} noToken
 * @returns
 */
export function httpGet(url, noToken) {
	return request(url, null, "GET", noToken);
}

/**
 * Prepare the request (headers etc)
 * @param {*} url
 * @param {*} model
 * @param {*} method
 * @param {*} noToken
 * @returns
 */
const request = async (url, model, method, noToken) => {
	try {
		let requestOptions = {
			method: method,
			headers: { "Content-Type": "application/json" },
			body: model ? JSON.stringify(model) : null,
		};

		if (!noToken) {
			requestOptions = {
				...requestOptions,
				headers: {
					"Content-Type": "application/json",
					Token: localStorage.getItem("user"),
				},
			};
		}

		if (noToken || hasValidToken()) {
			const res = await httpRequest(url, requestOptions);
			
			return res;
		} else {
			
			await getNewToken();
			requestOptions.headers.Token = localStorage.getItem("user");
			return httpRequest(url, requestOptions);
		}
	} catch (e) {
		throw e;
	}
};

/**
 * The actual http request
 * @param {*} url
 * @param {*} requestOptions
 * @returns
 */
async function httpRequest(url, requestOptions) {
	try {
		const fullurl = `${process.env.REACT_APP_API_URL}${url}`;
		const response = await fetch(fullurl, requestOptions);
		if (response.ok) {
			const result = await response.json();
			if (process.env.NODE_ENV === "development")
				console.log('API RESULT', JSON.stringify({ url, result }, null, 2));
				return result;
		} else {
			const err = await response.json();
			if (err.message) {
				if (process.env.NODE_ENV === "development")
					console.log(
						"ERROR",
						JSON.stringify({ url, request, response, err }, null, 2)
					);
				throw err.message;
			} else {
				if (process.env.NODE_ENV === "development")
					console.log("ERROR", JSON.stringify({ url, request, response }, null, 2));
				throw err;
			}
		}
	} catch (e) {
		console.log(url, e);
		throw e;
	}
}

/**
 * POST a file
 * @param {*} url
 * @param {*} model
 * @returns
 */
export function httpPostFile(url, model) {
	let requestOptions = {
		method: "POST",
		headers: { Token: localStorage.getItem("user") },
		body: model,
	};

	return httpRequest(url, requestOptions);
}

/**
 * Check for a valid token
 * @returns
 */
export const hasValidToken = () => {
	var token = localStorage.getItem("user");
	if (!token) {
		return false;
	}
	try {
		var decodedToken = jwtDecode(token);
		var dateNow = new Date();
		var tokenExpDate = new Date(decodedToken.exp * 1000);
		if (tokenExpDate < dateNow) {
			// logoutLocalStorage();
			return false;
		}
		// if the time left is less than 10 minutes - then renew the token
		let res = Math.abs(dateNow - tokenExpDate) / 1000;
		let minutes = Math.floor(res / 60);
		if (minutes <= 10) {
			// If there's 3 hours left - renew the token
			// This task doesn't need an await - as it can run concurrently with other tasks
			renewToken();
		}
		return true;
	} catch (error) {
		return false;
	}
};

/**
 * Get a new token
 */
async function getNewToken() {
	try {
		
		
		const model = await request(
			
			`auth/register/${process.env.REACT_APP_SUBSCRIPTION_GUID}`,
			{},
			"POST",
			true
		);
		
	    
		localStorage.setItem("user", model.token);
	} catch (error) {
		throw error;
	}
}

/**
 * Renew the token
 */
export async function renewToken() {
	try {
		const model = await request("auth/renewtoken", {}, "POST");
		localStorage.setItem("user", model.token);
	} catch (error) {
		// Can add notification when the token cant be renewed
	}
}
